import React, { useEffect, useState } from "react";
import { sentimentTrackerOnboardingApis } from "stores/SentimentTracker/sentimentTrackerOnboarding/sentimentTrackerOnboardingApis";
import Stack from "components/common/Stack";
import { useSelector } from "react-redux";
import SentimentTrackerOnboardingNotCompleted from "../SentimentTrackerOnboardingNotCompleted";

function Dashboard() {
  const [urlData, setUrlData] = useState("");
  const isSentimentTrackerOnboardingCompleted = useSelector(
    (state) =>
      state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted
  );

  useEffect(() => {
    if (isSentimentTrackerOnboardingCompleted) {
      Promise.resolve(sentimentTrackerOnboardingApis.redirectOnboarding())
        .then((response) => {
          setUrlData(response?.data?.redirect_url || "");
        })
        .catch((error) => {
          console.error("Error while redirecting to dashboard", error);
        });
    }
  }, []);

  return (
    <>
      {isSentimentTrackerOnboardingCompleted ? (
        <div style={{ height: "100vh", width: "100%" }}>
          {urlData ? (
            <iframe
              src={urlData}
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          ) : (
            <Stack
              justifyContent="center"
              alignItems="center"
              sx={{
                height: "100%",
                background: "#fff",
              }}
            >
              <img src="/loader.gif" alt="loader" />
            </Stack>
          )}
        </div>
      ) : (
        <SentimentTrackerOnboardingNotCompleted />
      )}
    </>
  );
}

export default Dashboard;
